import React from 'react'

import { Box, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { DisplayScoirApplyIcon } from '@scoir/college-details/icons'
import PropTypes from 'prop-types'

import { getIsLocalPortDevMode, getUnauthedFallbackUrl } from 'common/api'
import { appProfileOverviewUrl } from 'common/scoir-apply-constants'
import { AuthShieldComponent, useIsAuthed } from 'components/AuthShield'
import { FEATURE_NAMES } from 'components/ConfiguredDynamicFeatureProvider/features'
import withDynamicFeature from 'components/DynamicFeatureProvider/WithDynamicFeature'
import FwdRefNavLink from 'components/FwdRefNavLink'

const useStyles = makeStyles((theme) => ({
  link: {
    zIndex: 3,

    [theme.breakpoints.down(910)]: {
      display: 'none',
    },
    '&:hover, &.active, &:focus': {
      textDecoration: 'none',
    },
  },
}))

/**
 * This component is a link to the app-profile overview
 * @returns Apply With Scoir button
 */
const ApplyWithScoir = () => {
  const classes = useStyles()
  const isAuthed = useIsAuthed()
  const Component = isAuthed ? FwdRefNavLink : getIsLocalPortDevMode() ? FwdRefNavLink : 'a'
  const urlProp = Component === 'a' ? 'href' : 'to'

  return (
    <Box
      ml={1}
      width="168px"
    >
      <AuthShieldComponent
        id="main-nav-apply-with-scoir-button"
        className={classes.link}
        size="large"
        variant="text"
        startIcon={<DisplayScoirApplyIcon isScoirApplyEnabled />}
        color="primary"
        component={Button}
        propsAuthed={{
          to: appProfileOverviewUrl,
          'aria-label': 'Apply with Scoir',
          component: Component,
        }}
        propsUnauthed={{
          [urlProp]: getUnauthedFallbackUrl(),
          'aria-label': 'Sign in to Apply with Scoir',
          component: Component,
        }}
      >
        Apply with Scoir
      </AuthShieldComponent>
    </Box>
  )
}

ApplyWithScoir.propTypes = {
  avatarUrl: PropTypes.string,
  className: PropTypes.string,
}

export default withDynamicFeature(ApplyWithScoir, { name: FEATURE_NAMES.MyColleges })
